/* Cart drawer progress bar.
   The drawer reuses its first render and only refreshes elements that
   listen for cart-drawer's update-nodes event. This element swaps in the
   bar from the section HTML Shopify returns after add, change, or remove. */
(function () {
  var TAG = 'c-cart-progress';

  if (customElements.get(TAG)) return;

  class CartProgress extends HTMLElement {
    connectedCallback() {
      this.unbind();
      this.drawer = this.closest('cart-drawer');
      if (this.drawer && typeof this.drawer.on === 'function') {
        this.drawer.on('update-nodes', this.onUpdate);
      }
    }

    disconnectedCallback() {
      this.unbind();
    }

    unbind() {
      if (this.drawer && typeof this.drawer.off === 'function') {
        this.drawer.off('update-nodes', this.onUpdate);
      }
      this.drawer = null;
    }

    onUpdate = ({ node } = {}) => {
      if (!node || typeof node.querySelectorAll !== 'function') return;
      var id = this.getAttribute('block-id');
      if (!id) return;
      var bars = node.querySelectorAll(TAG);
      var fresh = null;
      for (var i = 0; i < bars.length; i++) {
        if (bars[i].getAttribute('block-id') === id) {
          fresh = bars[i];
          break;
        }
      }
      if (!fresh) return;
      var copy = fresh.cloneNode(true);
      this.replaceChildren.apply(this, Array.prototype.slice.call(copy.childNodes));
    };
  }

  customElements.define(TAG, CartProgress);
})();
